import { render, staticRenderFns } from "./single-work-swift.vue?vue&type=template&id=4120c39d&scoped=true&lang=pug&"
import script from "./single-work-swift.vue?vue&type=script&lang=js&"
export * from "./single-work-swift.vue?vue&type=script&lang=js&"
import style0 from "./single-work-swift.vue?vue&type=style&index=0&id=4120c39d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4120c39d",
  null
  
)

export default component.exports